import React, { ReactNode } from 'react'

import { twMerge } from 'tailwind-merge'

import { type Url } from '@/types'
import Button from '@components/Button'

export interface SectionCTAProps {
  children: ReactNode
  iconName?: string
  url: Url
  ariaLabel?: string
  label?: string
  variant?: 'primary' | 'secondary' | 'link' | 'inlineLink'
  className?: string
}

export const SectionCTA: React.FC<SectionCTAProps> = ({
  children,
  iconName,
  url,
  ariaLabel,
  label,
  variant = 'primary',
  className,
}) => (
  <>
    {children && (
      <Button
        icon={{
          name: iconName || 'arrow',
          background: 'red',
          color: 'white',
        }}
        href={url.href}
        target={url.target}
        ariaLabel={ariaLabel || label}
        className={twMerge('self-center mt-10 md:mt-[50px]', className)}
        variant={variant}
      >
        {children}
      </Button>
    )}
  </>
)

export default SectionCTA
